import { LocaleMessages } from 'vue-i18n'

const paymentEnUsLocaleMessages: LocaleMessages = {
  subscription: {
    title: 'Subscription',
    pluralTitle: 'Subscriptions'
  },
  subscriptionPayload: {
    field: {
      id: 'Id',
      customer: 'Customer',
      planDescription: 'Plan Description',
      status: 'Status',
      billingType: 'Billing Type',
      cycle: 'Cycle',
      value: 'Value',
      nextDueDate: 'Next Due',
      partner: 'Partner',
      groupSerial: 'Serial No.',
      invoiceAmount: 'Invoice Amount',
      sellerId: 'Seller Id',
      createdDate: 'Created at'
    },
    alert: {
      command: {
        CREATE_ACCESS: 'Are you sure you want to create access for this subscription?'
      }
    },
    notification: {
      command: {
        CREATE_ACCESS: 'Access successfully created.'
      }
    },
    value: {
      status: {
        ACTIVE: 'Active',
        EXPIRED: 'Expired',
        INACTIVE: 'Inactive'
      },
      billingType: {
        UNDEFINED: 'Undefined',
        BOLETO: 'Boleto',
        CREDIT_CARD: 'Credit Card',
        DEBIT_CARD: 'Debit Card',
        TRANSFER: 'Transfer',
        DEPOSIT: 'Deposit',
        PIX: 'Pix'
      },
      cycle: {
        WEEKLY: 'Weekly',
        BIWEEKLY: 'Biweekly',
        MONTHLY: 'Monthly',
        BIMONTHLY: 'Bimonthly',
        QUARTERLY: 'Quarterly',
        SEMIANNUALLY: 'Semiannually',
        YEARLY: 'Yearly'
      },
      command: {
        CREATE_ACCESS: 'Create Access'
      }
    }
  },
  customer: {
    title: 'Customer',
    pluralTitle: 'Customers'
  },
  customerPayload: {
    field: {
      id: 'Id',
      name: 'Name',
      cpfCnpj: 'CPF / CNPJ',
      email: 'Email',
      phone: 'Phone',
      stateInscription: 'State Inscription',
      groupSeries: 'Series',
      postalCode: 'Postal code',
      address: 'Address',
      addressNumber: 'Number',
      complement: 'Complement',
      province: 'Province',
      city: 'City',
      state: 'State',
      country: 'Country',
      createdDate: 'Created at'
    }
  },
  partner: {
    title: 'Partner',
    pluralTitle: 'Partners'
  },
  partnerPayload: {
    field: {
      id: 'Id',
      name: 'Name',
      cpfCnpj: 'CPF / CNPJ',
      email: 'Email',
      phone: 'Phone',
      walletId: 'Wallet Id',
      postalCode: 'Postal code',
      address: 'Address',
      addressNumber: 'Number',
      complement: 'Complement',
      province: 'Province',
      city: 'City',
      state: 'State',
      country: 'Country'
    }
  }
}

export default paymentEnUsLocaleMessages